import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

const WhitelistPopup = ({ open, onClose, onConfirm, initialData = {},fetchSmsWhitelistOptions,fetchDataWhitelistOptions,dataWhitelistOptions,setDataWhitelistOptions,handleConfirmWhitelist,
    handleCloseWhitelistPopup,setTempWhitelistNumberGroup,tempWhitelistNumberGroup,setTempWhitelistIpGroup,tempWhitelistIpGroup,smsWhitelistOptions,setSmsWhitelistOptions,
    setIsWhitelistIpChecked,setIsWhitelistNumberChecked}) => {
    
  
    useEffect(() => {
      // Note: You must ensure these functions return a Promise that resolves to an array.
      fetchDataWhitelistOptions();
      fetchSmsWhitelistOptions()   
    }, []);
  
    const handleConfirm = () => {
      onConfirm({ tempWhitelistIpGroup, tempWhitelistNumberGroup });
      onClose();
    };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
       <div
               style={{
                 position: "fixed",
                 top: 0,
                 left: 0,
                 width: "100%",
                 height: "100%",
                 backgroundColor: "rgba(0, 0, 0, 0.6)",
                 display: "flex",
                 justifyContent: "center",
                 alignItems: "center",
                 zIndex: 10000,
                 backdropFilter: "blur(4px)",
                 animation: "fadeIn 0.3s ease-out",
               }}
             >
               <div
                 style={{
                   backgroundColor: "white",
                   borderRadius: "16px",
                   boxShadow:
                     "0 20px 50px rgba(0,0,0,0.15), 0 0 0 1px rgba(255,255,255,0.1)",
                   width: "520px",
                   maxWidth: "90%",
                   transform: "translateY(0)",
                   animation: "slideUp 0.3s ease-out",
                   overflow: "hidden",
                 }}
               >
                 <div
                   style={{
                     background:
                       "linear-gradient(135deg, var(--bg) 0%, var(--bg) 100%)",
                     color: "white",
                     padding: "1.5rem 2rem",
                     fontWeight: "600",
                     fontSize: "1.3rem",
                     textAlign: "center",
                     position: "relative",
                     overflow: "hidden",
                   }}
                 >
                   <div
                     style={{
                       position: "absolute",
                       top: 0,
                       left: 0,
                       right: 0,
                       bottom: 0,
                       background:
                         "linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)",
                       pointerEvents: "none",
                     }}
                   />
                   <div style={{ position: "relative", zIndex: 1 }}>
                     Configure Whitelist Settings
                   </div>
                 </div>
     
                 <div style={{ padding: "2.5rem" }}>
                   <div style={{ marginBottom: "2rem" }}>
                     <div
                       style={{
                         marginBottom: "0.75rem",
                         fontSize: "0.95rem",
                         fontWeight: "500",
                         color: "#374151",
                         display: "flex",
                         alignItems: "center",
                         gap: "0.5rem",
                       }}
                     >
                       Data Whitelist Group
                     </div>
                    
                     <Autocomplete
  fullWidth
  options={dataWhitelistOptions || []}
  getOptionLabel={(option) => option || ""}
  value={tempWhitelistIpGroup}
  onChange={(event, newValue) => {
    setTempWhitelistIpGroup(newValue || "");
    setIsWhitelistIpChecked(newValue);
  }}
  disablePortal={false} // ✅ renders outside the dialog
  PopperProps={{
    style: { zIndex: 20000 }, // ✅ ensures dropdown appears above dialog
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      variant="outlined"
      size="small"
      placeholder="Select Data White List Group"
      fullWidth
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px",
          transition: "all 0.2s ease",
          "&:hover": {
            boxShadow: "0 0 0 2px rgba(65, 81, 224, 0.1)",
          },
          "&.Mui-focused": {
            boxShadow: "0 0 0 3px rgba(65, 81, 224, 0.15)",
          },
        },
      }}
    />
  )}
/>

                     
                   </div>
                   <div style={{ marginBottom: "1.5rem" }}>
                     <div
                       style={{
                         marginBottom: "0.75rem",
                         fontSize: "0.95rem",
                         fontWeight: "500",
                         color: "#374151",
                         display: "flex",
                         alignItems: "center",
                         gap: "0.5rem",
                       }}
                     >
                       SMS Whitelist Group
                     </div>
                     <Autocomplete
  fullWidth
  options={smsWhitelistOptions || []}
  getOptionLabel={(option) => option || ""}
  value={tempWhitelistNumberGroup}
  onChange={(event, newValue) => {
    setTempWhitelistNumberGroup(newValue || "");
    setIsWhitelistNumberChecked(newValue);
  }}
  disablePortal={false}
  PopperProps={{
    style: { zIndex: 20000 },
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      variant="outlined"
      size="small"
      placeholder="Select SMS White List Group"
      fullWidth
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px",
          transition: "all 0.2s ease",
          "&:hover": {
            boxShadow: "0 0 0 2px rgba(65, 81, 224, 0.1)",
          },
          "&.Mui-focused": {
            boxShadow: "0 0 0 3px rgba(65, 81, 224, 0.15)",
          },
        },
      }}
    />
  )}
/>

                     
                   </div>
     
                   <div
                     style={{
                       marginTop: "1.5rem",
                       padding: "1rem 1.25rem",
                       background:
                         "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                       borderRadius: "12px",
                       fontSize: "0.9rem",
                       color: "#64748b",
                       border: "1px solid #e2e8f0",
                       position: "relative",
                     }}
                   >
                     <div
                       style={{
                         position: "absolute",
                         top: "0.75rem",
                         left: "1rem",
                         fontSize: "1.1rem",
                       }}
                     ></div>
                     <div style={{ marginLeft: "0rem" }}>
                       <strong style={{ color: "#475569" }}>Note:</strong> Fill in at
                       least one field to apply whitelist settings to the selected
                       SIMs.
                     </div>
                   </div>
                 </div>
     
                 <div
                   style={{
                     padding: "1.5rem 2.5rem 2.5rem",
                     display: "flex",
                     gap: "1rem",
                     justifyContent: "flex-end",
                     backgroundColor: "#fafbfc",
                     borderTop: "1px solid #f1f5f9",
                   }}
                 >
                   <Button
                     variant="outlined"
                     onClick={handleCloseWhitelistPopup}
                     sx={{
                       borderRadius: "8px",
                       padding: "0.75rem 1.5rem",
                       fontWeight: "500",
                       textTransform: "none",
                       borderColor: "#d1d5db",
                       color: "#6b7280",
                       transition: "all 0.2s ease",
                       "&:hover": {
                         borderColor: "#9ca3af",
                         backgroundColor: "#f9fafb",
                         transform: "translateY(-1px)",
                         boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                       },
                     }}
                   >
                     Cancel
                   </Button>
                   <Button
                     variant="contained"
                     onClick={handleConfirmWhitelist}
                  
                     sx={{
                       borderRadius: "8px",
                       padding: "0.75rem 1.5rem",
                       fontWeight: "500",
                       textTransform: "none",
                       backgroundColor: "var(--bg)",
                       color: "white",
                       transition: "all 0.2s ease",
                       "&:hover": {
                         backgroundColor: "var(--bg)",
                         transform: "translateY(-1px)",
                         boxShadow: "0 8px 20px rgba(65, 81, 224, 0.3)",
                       },
                       "&:disabled": {
                         backgroundColor: "#d1d5db",
                         color: "#9ca3af",
                         transform: "none",
                       },
                     }}
                   >
                     Apply Whitelist
                   </Button>
                 </div>
               </div>
     
               <style jsx>{`
                 @keyframes fadeIn {
                   from {
                     opacity: 0;
                   }
                   to {
                     opacity: 1;
                   }
                 }
     
                 @keyframes slideUp {
                   from {
                     opacity: 0;
                     transform: translateY(20px) scale(0.95);
                   }
                   to {
                     opacity: 1;
                     transform: translateY(0) scale(1);
                   }
                 }
               `}</style>
             </div>
    </Dialog>
  );
};

export default WhitelistPopup;